export const isTouchDevice = "ontouchstart" in document.documentElement;
